import { isAbsoluteEmpty, isTextPrimitive } from 'ziphy-web-shared/basic/helpers';
export const normalizeMultiSelectValueToMap = (originalValue) => {
    const map = new Map();
    if (isAbsoluteEmpty(originalValue))
        return map;
    if (isTextPrimitive(originalValue)) {
        map.set(originalValue, {
            id: originalValue,
            type: getValueType(originalValue),
        });
    }
    else if (Array.isArray(originalValue)) {
        originalValue.forEach((item, index) => {
            map.set(item, {
                id: item,
                type: getValueType(originalValue),
                index,
            });
        });
    }
    else {
        Object.keys(originalValue).forEach((key) => {
            const val = originalValue[key];
            if (val === false)
                return;
            map.set(key, {
                id: key,
                type: getValueType(originalValue),
                extra: typeof val === 'string' ? val : undefined,
            });
        });
    }
    return map;
};
export const getValueType = (originalValue) => {
    if (!originalValue || isTextPrimitive(originalValue))
        return 'primitive';
    if (Array.isArray(originalValue))
        return 'array';
    return 'object';
};
export const getClearValue = (multi, originalValue) => {
    if (typeof originalValue === 'string') {
        return '';
    }
    if (Array.isArray(originalValue)) {
        return [];
    }
    return multi ? [] : undefined;
};
export const denormalizeMultiSelectValueFromMap = (normalizedValue, multi, originalValue) => {
    var _a, _b, _c, _d, _e;
    if (originalValue === undefined)
        return multi ? [] : undefined;
    const first = normalizedValue.values().next();
    if (((_a = first.value) === null || _a === void 0 ? void 0 : _a.type) === 'primitive' || isTextPrimitive(originalValue)) {
        return (_c = (_b = first.value) === null || _b === void 0 ? void 0 : _b.other) !== null && _c !== void 0 ? _c : (_d = first.value) === null || _d === void 0 ? void 0 : _d.id;
    }
    if (((_e = first.value) === null || _e === void 0 ? void 0 : _e.type) === 'array' || Array.isArray(originalValue)) {
        return Array.from(normalizedValue.values()).map((x) => { var _a; return (_a = x.other) !== null && _a !== void 0 ? _a : x.id; });
    }
    const result = {};
    normalizedValue.forEach((value, key) => {
        if (value.other !== undefined) {
            result[value.other] = true;
        }
        else if (value.extra !== undefined) {
            result[key] = value.extra;
        }
        else {
            result[key] = true;
        }
    });
    return result;
};
